/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file API to check if URL contains at least one query string parameter
 * @author Alex Brizius
 */

import { getQueryStringParameter } from "./get-query-string-parameter";

export function hasAtLeastOneQueryStringParameter(href: string, keys: string[]): boolean {
	for (const index in keys ){
		if (getQueryStringParameter(href, keys[index])) {
			return true;
		}
	}
	return false;
}